import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { PipesModule } from '../pipes/pipes.module';
import { ImportViewComponent } from './import-view.component';
import { CsvImporterComponent } from './csv-importer/csv-importer.component';
import { UploadComponent } from './csv-importer/upload/upload.component';
import { MatcherComponent } from './csv-importer/matcher/matcher.component';
import { ImportStatusComponent } from './csv-importer/import-status/import-status.component';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule } from '@angular/forms';
import { ContactImporterComponent } from './contact-importer/contact-importer.component';


@NgModule({
    declarations: [
        ImportViewComponent,
        CsvImporterComponent,
        UploadComponent,
        MatcherComponent,
        ImportStatusComponent,
        ContactImporterComponent
    ],
    providers: [DecimalPipe, CurrencyPipe, DatePipe],
    imports: [
        CommonModule,
        PipesModule,
        DirectivesModule,
        FormsModule
    ],
    exports: [
        ImportViewComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ImportModule {
  customElementComponent: Type<any> = ImportViewComponent;

  constructor() {}

  ngDoBootstrap() { }
}
